module.exports = __webpack_public_path__ + "img/enterprise-avenue.aeddd04c.jpg";